(() => {
  if (customElements.get('main-product')) {
    return;
  }

  class MainProduct extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachEvents();
    }

    attachEvents() {
      document.addEventListener(
        'DOMContentLoaded',
        this.toggleHidePromoBar.bind(this),
      );
      window.addEventListener('scroll', this.toggleHidePromoBar.bind(this));
    }

    toggleHidePromoBar() {
      const sectionBottomPosition = this.offsetTop + this.offsetHeight;

      document.body.classList.toggle(
        'hide-promo-bar',
        window.scrollY + window.innerHeight >= sectionBottomPosition,
      );
    }
  }

  customElements.define('main-product', MainProduct);
})();
